/*
  Einstiegspunkt für den Schichtplan der Mitarbeitenden (/shiftplan für User).
  Gleiche Raster-Styles wie die Planung; Bearbeitungs-Styles fehlen bewusst.
*/

import "../../../design-system/styles/tokens.css";
import "../../../design-system/styles/components.css";
import "../../shiftplan_v2/styles/base.css";
import "../../shiftplan_v2/styles/toolbar.css";
import "../../shiftplan_v2/styles/month-grid.css";
import "../../shiftplan_v2/styles/dialog.css";
import "./employeeShiftplan.css";
import EmployeeShiftplanPage from "./EmployeeShiftplanPage";

export default EmployeeShiftplanPage;
